import * as _4 from 'lodash';
import { INVALID_ID } from '../../../global/constants/ap_id_constants';
import { APGenericSlot, CourseGroupSlot } from '../../builders/ap_generic_slot_builder';
import { APComponentStateModel } from '../../models/ap_component_state_model';
import { APGenericSlotServant } from '../../servants/ap_generic_slot_servant';

export class CourseGroupTile {
  courseGroupModifierButtonLabel: string;
  groupExpanded: boolean;
  notifyCollapse: any;
  type: string;
  slot: CourseGroupSlot;
  id: CourseGroupSlot['programSlot']['id'];
  isPlanned: boolean;
  isEditable: boolean | string;
  isCourseGroupPlanned: boolean;
  showAllCoursesOption: boolean;
  courseStartIndex: number;
  courseEndIndex: number;
  badgeType: string;
  isLocked: boolean = false;
  theme: string;
  UIDAppend: string = _4.uniqueId();

  // TODO: Check the possibility to grab from query
  calculateCourseGroupLimit() {
    const MAX_NUMBER_COURSES = 6;
    const SHOW_ALL_COURSES_LIMIT = 10;
    this.showAllCoursesOption = this.slot.programSlot.total_courses > SHOW_ALL_COURSES_LIMIT;
    this.courseStartIndex = 0;
    this.courseEndIndex = this.showAllCoursesOption ? MAX_NUMBER_COURSES : this.slot.programSlot.total_courses;
  }

  constructor(private ngAPComponentStateModel: APComponentStateModel) {}

  $onChanges() {
    this.badgeType = this.type && !!this.slot.plannedCourse ? this.type : 'placeholder';
    this.isEditable = _4.isBoolean(this.isEditable) ? this.isEditable : this.isEditable === 'true';
    this.calculateCourseGroupLimit();
    this.isLocked = _4.get(this.slot, 'isLockedByAdvisor', false);
    this.theme = this.themeColor();
  }

  themeColor() {
    return this.slot.disableSlot ? 'gray' : 'primary';
  }

  $onInit() {
    this.id = this.slot.programSlot.id;
    const noTermAssigned = this.slot.termId === INVALID_ID;
    this.isPlanned = APGenericSlotServant.isGenericSlotPlanned(this.slot) && noTermAssigned;
    this.isCourseGroupPlanned = APGenericSlotServant.isGenericSlotPlanned(this.slot);
    this.updateComponentState(this.id, _4.get(this.ngAPComponentStateModel, `courseGroups[${this.id}].opened`, false));
    this.calculateCourseGroupLimit();
    this.theme = this.themeColor();
  }

  get _hasRequisiteProblem() {
    return _4.get(this.slot, 'plannedCourse._hasRequisiteProblem', false);
  }

  headingClicked() {
    if (this.slot.showMarkAsUnmetMenu || this.slot.disableSlot) {
      return;
    }
    if (!this.isPlanned) {
      this.updateComponentState(this.id, !this.groupExpanded);
    }
  }

  updateComponentState(id: CourseGroupSlot['programSlot']['id'], state: boolean) {
    if (!this.ngAPComponentStateModel.courseGroups[id]) {
      this.ngAPComponentStateModel.courseGroupClose(id);
    } else {
      this.ngAPComponentStateModel.courseGroupToggle(id, this.isCourseGroupPlanned ? false : state);
    }
    this.groupExpanded = state;
  }

  getIconPosition() {
    return this.groupExpanded ? '90' : '0';
  }
}

angular.module('capability-ng-academic-planner').component('courseGroupTile', {
  templateUrl: 'capability-ng-academic-planner/src/global/components/course_group_tile/course_group_tile.html',
  bindings: {
    slot: '<',
    groupExpanded: '<',
    term: '<',
    notifyCollapse: '&',
    type: '@',
    isEditable: '<?'
  },
  controller: CourseGroupTile,
  transclude: true
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/course_group_tile/course_group_tile.ts